(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__lrsAutoVideo) return;
    window.__lrsAutoVideo = true;

    function play(v) {
      if (!v.src && v.dataset.src) v.src = v.dataset.src;
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    var io = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) play(e.target);
            else if (!e.target.paused) e.target.pause();
          });
        }, { rootMargin: '150px 0px', threshold: 0.01 })
      : null;

    function init() {
      var vids = document.querySelectorAll('video.lrs-av:not([data-lrs-init])');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        v.setAttribute('data-lrs-init', '1');
        v.muted = true;
        if (io) io.observe(v); else play(v);
      }
    }

    var queued = false;
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; init(); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        document.querySelectorAll('video.lrs-av[src]').forEach(function (v) {
          var r = v.getBoundingClientRect();
          if (r.bottom > 0 && r.top < innerHeight && r.width > 0) play(v);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
